//
//
//
//
//
//

export default {
    name: 'SectionIndicators',
    props: {
        anchor: {
            required: true,
            type: String,
        },
    },
}



// WEBPACK FOOTER //
// ./scripts/vue/components/ui/SectionIndicators.vue